import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Lazy load translations - only load the default language initially
import global_en from './translations/eng/global.json';

i18next.init({
  interpolation: { escapeValue: false },
  lng: 'en',
  resources: {
    en: {
      global: global_en,
    },
  },
});

// Load other languages dynamically when needed
export const loadLanguage = async (lng) => {
  if (i18next.hasResourceBundle(lng, 'global')) {
    return;
  }
  
  try {
    let translation;
    switch (lng) {
      case 'es':
        translation = await import('./translations/esp/global.json');
        break;
      case 'de':
        translation = await import('./translations/deu/global.json');
        break;
      case 'jp':
        translation = await import('./translations/jpn/global.json');
        break;
      default:
        return;
    }
    i18next.addResourceBundle(lng, 'global', translation.default || translation, true, true);
  } catch (error) {
    console.error(`Failed to load language ${lng}:`, error);
  }
};

// Preload languages on idle time (low priority)
if ('requestIdleCallback' in window) {
  requestIdleCallback(() => {
    Promise.all([
      loadLanguage('es'),
      loadLanguage('de'),
      loadLanguage('jp'),
    ]).catch(() => {
      // Silently fail if languages can't be loaded
    });
  }, { timeout: 2000 });
} else {
  // Fallback for browsers without requestIdleCallback
  setTimeout(() => {
    Promise.all([
      loadLanguage('es'),
      loadLanguage('de'),
      loadLanguage('jp'),
    ]).catch(() => {});
  }, 2000);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <App />
    </I18nextProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
